import { cx } from "class-variance-authority";
import { ClassValue } from "class-variance-authority/types";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(cx(inputs));
}
export function getInitials(name: string = "") {
  const parts = name.trim().split(/\s+/);

  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  if (parts.length === 2) {
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }
  if (parts.length === 3) {
    // For three parts, assume it's first name + two surnames; use the first surname.
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }
  // For four or more parts, assume the name has a middle name: use the first and the first surname after the middle name.
  return (parts[0].charAt(0) + parts[2].charAt(0)).toUpperCase();
}

export const updateUrl = (drawers: any) => {
  // Convert the drawers to a query parameter or path segment
  const queryParams = drawers
    .map((d: any) => `drawer=${d.entity}:${d.entityId}`)
    .join("&");
  window.history.pushState(null, "", `?${queryParams}`);
};

export const getExt = (str: string) => {
  if (typeof str === "string" && str.includes(".")) {
    return str.split(".").pop();
  }
  return "";
};

export const getParamsDoc = (path: string, getValues: any) => {
  const urlParams = new URLSearchParams(path);

  const doc = urlParams.get("document");

  const url = getValues(doc);

  if (!url) urlParams.delete("document");

  return urlParams.toString();
};

export const getSubNum = (path: string) => {
  return !isNaN(parseInt(path[path.length - 1])) &&
    path[path.length - 2] === "."
    ? 2
    : 0;
};
